import { Component } from '@angular/core';
import { RoutesListComponent } from "../../../../components/admin-dashboard-component/admin-routes-component/routes-list-component/routes-list-component";

@Component({
  selector: 'app-route-list',
  imports: [RoutesListComponent],
  templateUrl: './route-list.html',
  styleUrl: './route-list.scss'
})
export class RouteList {

}
